//import { Button } from './Button';

import './Footer.css';
import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';

import facebook_icon from '../icons/monocromatic-icons-04.png';
import instagram_icon from '../icons/monocromatic-icons-05.png';
import twitter_icon from '../icons/monocromatic-icons-06.png';

import github_icon from '../icons/monocromatic-icons-07.png';
import linkedin_icon from '../icons/monocromatic-icons-08.png';

import artstation_icon from '../icons/monocromatic-icons-09.png';
import deviantart_icon from '../icons/monocromatic-icons-10.png';
import pinterest_icon from '../icons/monocromatic-icons-11.png';


function Footer() {

  useEffect(() => {
    window.scrollTo(0, 0)
  })

  return (
    <div className='footer-container'>
      {/*
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
          Join my newsletter for new designs.
        </p>
        <p className='footer-subscription-text'>
          You can unsubscribe at any time.
        </p>
        <div className='input-areas'>
          <form>
            <input
              className='footer-input'
              name='email'
              type='email'
              placeholder='Your email'
            />
            <Button buttonStyle='btn-outline'>Subscribe</Button>
          </form>
        </div>
      </section>
      */}
      <div class='footer-links'>
        <div className='footer-link-wrapper'>
          <div class='footer-link-items'>
            <h2>About me</h2>
            <Link to='/contact'>Contact</Link>
            <Link to='/education'>Education</Link>
            <Link to='/interests'>Interests</Link>
            <Link to='/projects'>Projects</Link>
          </div>
          <div class='footer-link-items'>
            <h2>Social Media</h2>
            <a href="https://www.facebook.com/jefthedev" target='_blank' rel="noopener noreferrer">Facebook</a>
            <a href="https://www.instagram.com/jefthedev" target='_blank' rel="noopener noreferrer">Instagram</a>
            <a href="https://www.twitter.com/jefthedev" target='_blank' rel="noopener noreferrer">Twitter</a>
          </div>
        </div>
      </div>
      <section class='social-media'>
        <div class='social-media-wrap'>
          <div class='social-icons'>
            <a href="https://www.facebook.com/jefthedev"
              class='social-icon-link facebook'
              target='_blank'
              rel="noopener noreferrer"
              aria-label='Facebook'
            >
              <img src={facebook_icon} className="footer-icon" />
            </a>
            <a href="https://www.instagram.com/jefthedev"
              class='social-icon-link instagram'
              target='_blank'
              rel="noopener noreferrer"
              aria-label='Instagram'
            >
              <img src={instagram_icon} className="footer-icon" />
            </a>
            <a href="https://www.twitter.com/jefthedev"
              class='social-icon-link twitter'
              target='_blank'
              rel="noopener noreferrer"
              aria-label='Twitter'
            >
              <img src={twitter_icon} className="footer-icon" />
            </a>
            <a href="https://www.github.com/jefthedev"
              class='social-icon-link github'
              target='_blank'
              rel="noopener noreferrer"
              aria-label='Github'
            >
              <img src={github_icon} className="footer-icon" />
            </a>
            <a href="https://www.linkedin.com/in/jefthedev"
              class='social-icon-link linkedin'
              target='_blank'
              rel="noopener noreferrer"
              aria-label='LinkedIn'
            >
              <img src={linkedin_icon} className="footer-icon" />
            </a>
            <a href="https://www.artstation.com/jefthedev"
              class='social-icon-link artstation'
              target='_blank'
              rel="noopener noreferrer"
              aria-label='Artstation'
            >
              <img src={artstation_icon} className="footer-icon" />
            </a>
            <a href="https://www.deviantart.com/jefthedev"
              class='social-icon-link artstation'
              target='_blank'
              rel="noopener noreferrer"
              aria-label='Deviantart'
            >
              <img src={deviantart_icon} className="footer-icon" />
            </a>
            <a href="https://www.pinterest.com/jefthedev"
              class='social-icon-link pinterest'
              target='_blank'
              rel="noopener noreferrer"
              aria-label='Pinterest'
            >
              <img src={pinterest_icon} className="footer-icon" />
            </a>
          </div>
        </div>
      </section>
      <small class='website-rights'>jefthedev © 2026</small>
    </div>
  );
}

export default Footer;
